import { StyleSheet } from 'react-native';
import Theme, { fontStyles } from 'Theme';

const defaultStyles = StyleSheet.create({
    outerItemContainer: {
        marginHorizontal: 10
    },
    innerItemContainer: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start'
    },
    itemName: {
        ...fontStyles.subtitle,
        paddingVertical: 18,
        maxWidth: '85%',
        color: Theme.labelTextColor,
        fontSize: Theme.fontSizes.description
    },
    itemNameWithDescription: {
        paddingTop: 14,
        paddingBottom: 5,
        maxWidth: '85%'
    },
    touchableItemName: {
        marginVertical: 12
    },
    itemDescription: {
        ...fontStyles.title,
        fontSize: Theme.fontSizes.sectionValue,
        fontFamily: Theme.regularFont,
        paddingVertical: 0,
        paddingBottom: 12
    }
});

export default defaultStyles;
